// @flow
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {isEmpty} from 'lodash';

import actions from '../../actions/searchBanner';
import {HA_SERP_DESTINATION_URGENCY_MSG} from '../../abacus/experiments';
import {Content as UrgentMessageSearchBannerContent} from './urgentMessageContents';
import {Content as PercentBookedSearchBannerContent} from './percentBookedContents';
import {Content as DestinationMessageContent} from './destinationMessage';
import SearchBanner from './SearchBanner';
import AlarmClockIcon from './AlarmClockIcon';

import type {State as ReduxState} from '../../reducers/index';
import type {State as SearchBannerState} from '../../reducers/searchBanner';
import type DestinationMessage from '@homeaway/graphql-traveler-urgency-messaging';

export const PERCENT_BOOK = 'PERCENT_BOOK';
export const URGENT_MESSAGE = 'URGENT_MESSAGE';

type SearchBannerPercentBook = {
    type: typeof PERCENT_BOOK,
    percentageLeft: number,
    location?: string
};

type SearchBannerUrgentMessage = {
    type: typeof URGENT_MESSAGE,
    countOfVisitors: number,
    location?: string
};

type SearchBannerUnknown = {
    type: string
};

export type SearchBannerData =
    | SearchBannerPercentBook
    | SearchBannerUrgentMessage
    | SearchBannerUnknown;

type StateProps = {
    q: string,
    searchBanner: SearchBannerState,
    isDatedSearch: boolean,
    isDestinationUrgency: number
};

type Props = {
    onHide: typeof actions.searchBannerAddLocation,
    bannerData?: SearchBannerData,
    isDatedSearch: boolean,
    urgencyMessage?: DestinationMessage
} & StateProps;

export class SearchBannerContainer extends Component<Props> {
    dismissBanner = () => {
        const {q, onHide} = this.props;
        onHide(q);
    };

    render() {
        const {
            isDatedSearch,
            bannerData,
            q,
            searchBanner,
            urgencyMessage,
            isDestinationUrgency
        } = this.props;

        if (q in searchBanner.dismissedLocations) {
            return null;
        }

        let isUrgencyMessage =
            isDestinationUrgency &&
            !isEmpty(urgencyMessage) &&
            (!isEmpty(urgencyMessage.iconTitleTextV3) ||
                !isEmpty(urgencyMessage.iconTextV1));

        let content;
        let icon;

        if (bannerData && !isUrgencyMessage && !isDestinationUrgency) {
            switch (bannerData.type) {
                case PERCENT_BOOK:
                    content = (
                        <PercentBookedSearchBannerContent {...bannerData} />
                    );
                    icon = <AlarmClockIcon />;
                    break;
                case URGENT_MESSAGE:
                    if (isDatedSearch) {
                        content = (
                            <UrgentMessageSearchBannerContent {...bannerData} />
                        );
                        icon = <AlarmClockIcon />;
                    }
                    break;
                default:
                    break;
            }
        }

        if (isUrgencyMessage) {
            content = <DestinationMessageContent {...urgencyMessage} />;
        }

        return content ? (
            <SearchBanner icon={icon} onDismiss={this.dismissBanner}>
                {content}
            </SearchBanner>
        ) : null;
    }
}

const mapStateToProps = ({
    searchParams: {params},
    searchBanner,
    abacus
}: ReduxState): StateProps => {
    const q = params.q || '';
    const isDatedSearch = !!(params.arrival && params.departure);
    const isDestinationUrgency = (abacus[HA_SERP_DESTINATION_URGENCY_MSG] || {})
        .value;
    return {isDatedSearch, q, searchBanner, isDestinationUrgency};
};

const mapDispatchToProps = {
    onHide: actions.searchBannerAddLocation
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SearchBannerContainer);
